import { accountMembersClient } from '@/api/clients/index';
import { isBoolean } from 'lodash-es';

export default (accountId = null) => {
  if (!accountId) {
    return false;
  }

  return {
    name: 'assignee',
    label: 'Assignee',
    fetchOptions: async () => {
      try {
        const response = await accountMembersClient.list(accountId);

        return Promise.resolve({
          data: (response?.data?.data || []).map((item) => ({
            value: item.id,
            label: item.fullName,
          })),
          meta: response?.data?.meta || null,
        });
      } catch (error) {
        return Promise.reject(error);
      }
    },
    getMessage: async (value, cb) => {
      if (isBoolean(value)) {
        cb(value);
      }

      let ids = value;

      if (typeof ids === 'string') {
        ids = ids.split(',');
      }

      if (Array.isArray(ids) === false) {
        ids = [ids];
      }

      try {
        const response = await accountMembersClient.list(accountId);

        const labels = ids.map((id) => {
          const member = response.data.data.find((memberItem) => memberItem.id === id);

          return member ? member.fullName : id;
        });

        return Promise.resolve(cb(labels));
      } catch (error) {
        return Promise.resolve(cb(value));
      }
    },
    filters: [
      {
        name: 'has_assignee',
        label: "Doesn't have assignee",
        input: 'none',
        value: false,
        message: () => "Doesn't have **assignee**",
      },
      {
        name: 'assignee_is',
        label: 'Assignee is',
        input: 'chips',
        value: null,
        message: (value) => `**assignee** is **${value}**`,
      },
      {
        name: 'assignee_is_not',
        label: 'Assignee is not',
        input: 'chips',
        value: null,
        message: (value) => `**assignee** is not **${value}**`,
      },
      {
        name: 'assignee_in',
        label: 'Assignee is one of',
        input: 'chips:multiple',
        value: [],
        message: (value) => `**assignee** is one of **${value.join(', ')}**`,
      },
      {
        name: 'assignee_not_in',
        label: 'Assignee is not one of',
        input: 'chips:multiple',
        value: [],
        message: (value) => `**assignee** is not one of **${value.join(', ')}**`,
      },
    ],
  };
};
